import { AccountingProductAPI } from "../api";
import i18n from '@/plugins/vue-i18n';

export class AccountingProduct {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
    this.typeString = data.type ? i18n.t(`accounting_product.type.${data.type}`) : ''
  }
  static async getAccountingProducts(payload) {
    const { data } = await AccountingProductAPI.getAccountingProducts(payload);
    return data.result.map((item) => (item = new AccountingProduct(item)));
  }
  static async createAccountingProduct(formData) {
    const { data } = await AccountingProductAPI.createAccountingProduct(formData);
    return new AccountingProduct(data.result);
  }
  static async updateAccountingProduct(formData) {
    const { data } = await AccountingProductAPI.updateAccountingProduct(formData);
    return new AccountingProduct(data.result);
  }
  static async getAccountingProductsByIds(ids) {
    const { data } = await AccountingProductAPI.getAccountingProductsByIds(ids);
    return data.result.map((item) => (item = new AccountingProduct(item)));
  }
  static async removeAccountingProduct(accountingProductId) {
    const { data } = await AccountingProductAPI.removeAccountingProduct(accountingProductId);
    return new AccountingProduct(data.result);
  }
}